module.exports = {
      id: "star-fill-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svg-sprite-00c6e45adeae57b8110f96850115bf46.svg#star-fill",
      toString: function () {
        return this.url;
      }
    }